{
  "nl": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Verander afbeelding inlogpagina",
        "new": "Client Toevoegen",
        "setAsPrimary": "Instellen als primair",
        "submit": "Opslaan",
        "undoChanges": "Ongedaan maken"
      },
      "attributes": {
        "address": "Adres",
        "aftercare_conversation_enabled": "Nazorggesprekken",
        "backgroundImage": "Afbeelding loginpagina",
        "email_address": "Email",
        "email_address_invoicing": "E-mail facturatie",
        "email_address_renewal": "Herinneringsmail contractverlenging",
        "email_address_reply_to": "\"Reply-to\" Email Adres",
        "email_address_ziggu": "\"From\" Email Adres",
        "iban": "IBAN",
        "language": "Taal",
        "languages": "Bedrijfstalen",
        "name": "Naam",
        "phone": "Telefoonnummer",
        "storage_sum": "Opslag gebruik",
        "storage_sum_max": "Je gebruikt momenteel {percentage}% van jouw totale opslag({gigabytes} GB)",
        "subdomain": "Subdomein",
        "timezone": "Tijdzone",
        "vat_number": "BTW-nummer"
      },
      "client_types": {
        "architects_designers": "Architecten en ontwerpers",
        "creative_agencies": "Creatieve bureaus",
        "general_specialized_contractors": "Algemene & gespecialiseerde aannemers",
        "makers_manufacturers": "Fabrikanten",
        "planners_coordinators": "Planners en coördinatoren",
        "property_developers": "Projectontwikkelaars"
      },
      "integrations": {
        "api_docs_info": "Voor meer informatie over onze API, raadpleeg onze",
        "api_documentation": "API-documentatie"
      },
      "labels": {
        "activeProjects": "Actieve projecten",
        "activeProjectsUsed": "{0} projecten actief, {1} nog niet gebruikt",
        "activeUnits": "Actieve units",
        "activeUnitsUsed": "{0} units actief, {1} nog niet in gebruik",
        "after_care_categories": "Categorieën",
        "after_care_statuses": "Statussen",
        "aftercare": "Nazorg",
        "bookADemo": "Boek een demo",
        "by": "Van {client}",
        "categories": "Categorieën",
        "category": "Categorie",
        "chatWithUs": "Chat met ons",
        "companyProfile": "Bedrijfsprofiel",
        "contactIntercom": "Contacteer ons via de chat indien je dit wil wijzigen.",
        "contactZiggu": "Heb je een vraag aan Ziggu? Zit je ergens mee? Product advies? Laten we chatten!",
        "conversations": "Gesprekken",
        "dashboard": "Dashboard",
        "decisions": "Beslissingen",
        "default_payment_overdue": "U heeft een achterstallige factuur voor Ziggu. Gelieve deze meteen te voldoen om intresten te vermijden. Vragen? Aarzel niet om ons te contacteren.",
        "delete_category": "Verwijder {category} categorie?",
        "delete_category_expl": "Het verwijderen van een documentcategorie kan niet ongedaan worden gemaakt. Bestaande documenten met deze categorie worden gewijzigd in categorie Overige",
        "document_categories": "Categorieën",
        "documents": "Documenten",
        "email_address_invoicing_info": "Nieuwe facturen sturen we naar dit adres.",
        "email_address_renewal_info": "We sturen e-mails naar het adres wanneer de verlengingsdatum van uw abonnement nadert en we willen u hierover informeren samen met alle nodige informatie.",
        "email_address_reply_to": "Dit email adres zal gebruikt worden wanneer iemand antwoordt op een email verstuurd via {email_address_ziggu}. Contacteer ons via de chat indien je dit wil wijzigen.",
        "email_address_ziggu": "Dit email address wordt gebruikt als het FROM adres van alle emails verstuurd via het platform (emails omtrent notificaties, uitnodigingen, wachtwoord resets, ...)",
        "email_forwarder_must_be_owner": "Alleen teamleden met de rol 'Eigenaar' kunnen e-mails doorsturen.",
        "email_forwarding_activated": "Stuur e-mails door naar Ziggu",
        "email_forwarding_activated_project": "Stuur e-mails door naar {project}",
        "email_forwarding_disclaimer": "Om spam te voorkomen, worden alleen e-mails verwerkt die zijn verzonden vanaf een adres dat is gekoppeld aan een <b>bestaand profiel eigenaar/beheerder</b>.<br>E-mails van onbekende afzenders worden genegeerd.",
        "email_forwarding_is": "Jouw doorstuuradres is",
        "financials": "Financiën",
        "general": "Algemeen",
        "goToSettings": "Instellingen",
        "helpcenter": "Helpcentrum",
        "inbound_email": "Inkomende e-mail",
        "invoice_overdue": "U heeft een betalingsachterstand. Contacteer ons via accounting{'@'}ziggu.io voor meer informatie.",
        "invoice_overdue_title": "Openstaande factuur",
        "language": "Dit is de standaard taal voor de login pagina, klanten en teamleden.",
        "languages": "De primaire taal is de standaard voor het invoeren van inhoud en kan niet worden verwijderd. Voeg extra talen toe om meertalige inhoud te ondersteunen. Klik op een extra taal om deze als primaire taal in te stellen.",
        "mobile_app_disabled": "Mobiele app (PWA) niet actief",
        "mobile_app_enabled": "Mobiele app (PWA) actief",
        "mobile_app_info": "Stuur ons een bericht op Intercom voor meer informatie!",
        "mustBeJPG": "Moet .jpg formaat zijn",
        "new_categories": "Extra categorieën",
        "new_document_category": "Categorie",
        "noCategories": "Je hebt nog geen categorieën. Maak er een aan om te beginnen.",
        "other": "Andere",
        "outOfOffice": "Out of office",
        "outOfOfficeMessage": "Out of office bericht (optioneel)",
        "packageUnits": "Geabonneerd op",
        "primary": "Primair",
        "removed_user": "Verwijderde gebruiker",
        "settings": {
          "click_to_copy": "Klik om token naar klembord te kopiëren",
          "copied_to_clipboard": "Token gekopieerd naar klembord"
        },
        "snippets": "Snippets",
        "subscription": "Abonnement",
        "subscriptionRenewalDate": "Verlengingsdatum",
        "subscriptionUsageUnits": "Huidig verbruik",
        "tab_aftercare": "Nazorg",
        "tab_company": "Bedrijf",
        "tab_information": "Informatie",
        "tab_integrations": "Integraties",
        "tab_settings": "Instellingen",
        "tab_subscription": "Abonnement",
        "tickets": "Gesprekken",
        "timezone": "Dit is de standaardtijdzone van het bedrijf",
        "translation_not_added_yet": "Vertaling is nog niet toegevoegd",
        "unchangeable_categories": "Standaardcategorieën die niet kunnen worden gewijzigd",
        "unchangeable_categories_info": "Deze categorieën zijn nodig voor de goede werking van het systeem of worden gebruikt in integraties.",
        "upgradePackageContactUs": "Neem contact met ons op om te beginnen",
        "upgradePackageSubtitleAftercare": "Met deze functionaliteit kan je klanten opvolgen na oplevering en hen helpen bij eventuele problemen met hun nieuwe thuis",
        "upgradePackageSubtitleConversationMentions": "Met deze functionaliteit kan je interne notities maken en teamleden taggen in een gesprek.",
        "upgradePackageSubtitleFinancials": "Creëer in een handomdraai een financieel overzicht voor elke koper",
        "upgradePackageSubtitleMilestones": "Met deze functie kan je op een eenvoudige manier de vooruitgang van de bouw per klant communiceren",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "Met deze functionaliteit kan je een tweede woningkoper uitnodigen voor het Ziggu-platform",
        "upgradePackageTitle": "Het lijkt erop dat je deze functionaliteit nog niet hebt",
        "warningooo": "OOO actief",
        "yourEmail": "Jouw e-mail",
        "zigguHome": "Ziggu startpagina"
      },
      "project_types": {
        "mup": "MUP's",
        "mup_and_sup": "MUP's en SUP's",
        "sup": "SUPs"
      },
      "toasts": {
        "attachment_category": {
          "create": "Documentcategorie gemaakt",
          "update": "Documentcategorie is bijgewerkt"
        }
      },
      "validation": {
        "attachment_category_required": "Categorie is verplicht",
        "duplicated_translation": "Dubbele vertaling",
        "mustBeEmailAddress": "Moet een emailadres zijn",
        "needName": "Verplicht veld"
      }
    }
  }
}
